import React, { useState } from 'react';

const fmt = (n) => `₱${Number(n||0).toLocaleString('en-PH',{minimumFractionDigits:2,maximumFractionDigits:2})}`;

function getPeriodsPerMonth(schedule) {
  if (schedule === 'Weekly')       return 4;
  if (schedule === 'Semi-monthly') return 2;
  return 1;
}

function splitContrib(monthly, schedule) {
  const periods = getPeriodsPerMonth(schedule);
  return Number((monthly / periods).toFixed(2));
}

export default function GovContribTab({ state, updateState, selectedBranchId }) {
  const [expandedId, setExpandedId] = useState(null);
  const [editingId, setEditingId]   = useState(null);
  const [form, setForm]             = useState({});
  const [filterBranch, setFilterBranch] = useState('all');

  const availBranches = state.branches.filter(b => !b.isMain);
  const employees = state.employees.filter(e =>
    (filterBranch === 'all' || e.branchId === filterBranch) &&
    e.status === 'Active'
  );

  function startEdit(emp) {
    setEditingId(emp.id);
    setExpandedId(emp.id);
    setForm({
      sssEmployee:        emp.sssEmployee        || 0,
      sssEmployer:        emp.sssEmployer        || 0,
      philhealthEmployee: emp.philhealthEmployee || 0,
      philhealthEmployer: emp.philhealthEmployer || 0,
      hdmfEmployee:       emp.hdmfEmployee       || 0,
      hdmfEmployer:       emp.hdmfEmployer       || 0,
      payrollSchedule:    emp.payrollSchedule    || 'Semi-monthly',
    });
  }

  function saveEdit(empId) {
    updateState(prev => ({
      ...prev,
      employees: prev.employees.map(e => e.id === empId ? {
        ...e,
        sssEmployee:        Number(form.sssEmployee        || 0),
        sssEmployer:        Number(form.sssEmployer        || 0),
        philhealthEmployee: Number(form.philhealthEmployee || 0),
        philhealthEmployer: Number(form.philhealthEmployer || 0),
        hdmfEmployee:       Number(form.hdmfEmployee       || 0),
        hdmfEmployer:       Number(form.hdmfEmployer       || 0),
        payrollSchedule:    form.payrollSchedule,
      } : e)
    }));
    setEditingId(null);
  }

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));

  // Summary totals
  const totalEmpShare = employees.reduce((s,e) =>
    s + (e.sssEmployee||0) + (e.philhealthEmployee||0) + (e.hdmfEmployee||0), 0);
  const totalEmrShare = employees.reduce((s,e) =>
    s + (e.sssEmployer||0) + (e.philhealthEmployer||0) + (e.hdmfEmployer||0), 0);

  return (
    <div>
      {/* Summary KPIs */}
      <div style={S.kpiRow}>
        {[
          { label: 'Active Employees',          value: employees.length,         color: '#4f46e5' },
          { label: 'Total Employee Share/mo',   value: fmt(totalEmpShare),       color: '#0891b2' },
          { label: 'Total Employer Share/mo',   value: fmt(totalEmrShare),       color: '#dc2626' },
          { label: 'Total Contributions/mo',    value: fmt(totalEmpShare + totalEmrShare), color: '#7c3aed' },
        ].map(k => (
          <div key={k.label} style={S.kpiBox}>
            <div style={{...S.kpiVal, color:k.color}}>{k.value}</div>
            <div style={S.kpiLabel}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Filter */}
      <div style={S.filterBar}>
        <div style={S.filterGroup}>
          <label style={S.label}>Branch</label>
          <select value={filterBranch} onChange={e => setFilterBranch(e.target.value)} style={S.input}>
            <option value="all">All Branches</option>
            {availBranches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        </div>
        <div style={{...S.filterGroup, justifyContent:'flex-end', flex:1}}>
          <p style={S.note}>💡 Monthly amounts are automatically split per payroll period</p>
        </div>
      </div>

      {/* Employee Cards */}
      {employees.length === 0 && (
        <div style={S.empty}>No active employees found. Add employees in the Employees tab first.</div>
      )}

      {employees.map(emp => {
        const branch = state.branches.find(b => b.id === emp.branchId)?.name || '';
        const isExpanded = expandedId === emp.id;
        const isEditing  = editingId  === emp.id;
        const schedule   = emp.payrollSchedule || 'Semi-monthly';
        const periods    = getPeriodsPerMonth(schedule);

        const sssEmp  = emp.sssEmployee        || 0;
        const sssEmr  = emp.sssEmployer        || 0;
        const phiEmp  = emp.philhealthEmployee || 0;
        const phiEmr  = emp.philhealthEmployer || 0;
        const hdmEmp  = emp.hdmfEmployee       || 0;
        const hdmEmr  = emp.hdmfEmployer       || 0;

        const totalEmp = sssEmp + phiEmp + hdmEmp;
        const totalEmr = sssEmr + phiEmr + hdmEmr;

        return (
          <div key={emp.id} style={S.card}>
            {/* Header Row */}
            <div style={S.cardHeader}>
              <div style={S.empInfo}>
                <div style={S.empName}>{emp.name}</div>
                <div style={S.empMeta}>
                  {branch} · Daily Rate: {fmt(emp.monthlySalary)} ·
                  <span style={{...S.badge,
                    background: schedule==='Weekly'?'#dbeafe':schedule==='Semi-monthly'?'#fef9c3':'#dcfce7',
                    color: schedule==='Weekly'?'#1d4ed8':schedule==='Semi-monthly'?'#854d0e':'#166534',
                    marginLeft:6
                  }}>
                    {schedule}
                  </span>
                </div>
              </div>
              <div style={S.headerRight}>
                <div style={S.summaryChips}>
                  <span style={S.chip}>👤 Emp: {fmt(totalEmp)}/mo</span>
                  <span style={{...S.chip, background:'#fee2e2', color:'#dc2626'}}>🏢 Emr: {fmt(totalEmr)}/mo</span>
                </div>
                <button
                  onClick={() => { startEdit(emp); }}
                  style={S.editBtn}
                >✏️ Edit</button>
                <button
                  onClick={() => setExpandedId(isExpanded ? null : emp.id)}
                  style={S.toggleBtn}
                >{isExpanded ? '▲ Hide' : '▼ View'}</button>
              </div>
            </div>

            {/* Expanded Detail */}
            {isExpanded && (
              <div style={S.detail}>
                {/* Per Period Breakdown */}
                {!isEditing && (
                  <>
                    <div style={S.sectionTitle}>📊 Monthly Contributions</div>
                    <table style={S.table}>
                      <thead>
                        <tr>
                          <th style={S.th}>Contribution</th>
                          <th style={{...S.th, textAlign:'right'}}>Employee Share/mo</th>
                          <th style={{...S.th, textAlign:'right'}}>Employer Share/mo</th>
                          <th style={{...S.th, textAlign:'right'}}>Per Period ({periods}x/mo)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { label:'SSS',       emp:sssEmp, emr:sssEmr },
                          { label:'PhilHealth',emp:phiEmp, emr:phiEmr },
                          { label:'HDMF',      emp:hdmEmp, emr:hdmEmr },
                        ].map((row,i) => (
                          <tr key={row.label} style={{background:i%2===0?'white':'#f8fafc'}}>
                            <td style={{...S.td, fontWeight:600}}>{row.label}</td>
                            <td style={{...S.td, textAlign:'right', color:'#0891b2'}}>{fmt(row.emp)}</td>
                            <td style={{...S.td, textAlign:'right', color:'#dc2626'}}>{fmt(row.emr)}</td>
                            <td style={{...S.td, textAlign:'right', color:'#7c3aed'}}>
                              {fmt(splitContrib(row.emp, schedule))} / {fmt(splitContrib(row.emr, schedule))}
                            </td>
                          </tr>
                        ))}
                        <tr style={{background:'#1e1b4b'}}>
                          <td style={{...S.td, color:'white', fontWeight:700}}>TOTAL</td>
                          <td style={{...S.td, textAlign:'right', color:'#93c5fd', fontWeight:700}}>{fmt(totalEmp)}</td>
                          <td style={{...S.td, textAlign:'right', color:'#fca5a5', fontWeight:700}}>{fmt(totalEmr)}</td>
                          <td style={{...S.td, textAlign:'right', color:'#c7d2fe', fontWeight:700}}>
                            {fmt(splitContrib(totalEmp, schedule))} / {fmt(splitContrib(totalEmr, schedule))}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div style={S.note2}>
                      💡 <strong>Employee share</strong> is deducted from salary only — not a company expense.<br/>
                      💡 <strong>Employer share</strong> is recorded as Operating Expense and deducted from company profit.
                    </div>
                  </>
                )}

                {/* Edit Form */}
                {isEditing && (
                  <div>
                    <div style={S.sectionTitle}>✏️ Edit Government Contributions</div>
                    
                    {/* Payroll Schedule */}
                    <div style={{marginBottom:16}}>
                      <label style={S.label}>Payroll Schedule</label>
                      <select
                        value={form.payrollSchedule}
                        onChange={e => set('payrollSchedule', e.target.value)}
                        style={{...S.input, width:200, marginTop:4}}
                      >
                        <option>Weekly</option>
                        <option>Semi-monthly</option>
                        <option>Monthly</option>
                      </select>
                    </div>

                    {/* Contribution Grid */}
                    {[
                      { label:'🔵 SSS',        empKey:'sssEmployee',        emrKey:'sssEmployer'        },
                      { label:'🟢 PhilHealth',  empKey:'philhealthEmployee', emrKey:'philhealthEmployer' },
                      { label:'🟠 HDMF',        empKey:'hdmfEmployee',       emrKey:'hdmfEmployer'       },
                    ].map(row => (
                      <div key={row.label} style={S.contribRow}>
                        <div style={S.contribLabel}>{row.label}</div>
                        <div style={S.contribFields}>
                          <div style={S.formGroup}>
                            <label style={S.label}>Employee Share / month</label>
                            <input
                              type="number" min="0"
                              value={form[row.empKey]}
                              onChange={e => set(row.empKey, e.target.value)}
                              style={S.input}
                              placeholder="0.00"
                            />
                          </div>
                          <div style={S.formGroup}>
                            <label style={S.label}>Employer Share / month</label>
                            <input
                              type="number" min="0"
                              value={form[row.emrKey]}
                              onChange={e => set(row.emrKey, e.target.value)}
                              style={S.input}
                              placeholder="0.00"
                            />
                          </div>
                          <div style={S.formGroup}>
                            <label style={S.label}>Per Period (auto)</label>
                            <div style={S.autoField}>
                              {fmt(splitContrib(Number(form[row.empKey]||0), form.payrollSchedule))} /
                              {fmt(splitContrib(Number(form[row.emrKey]||0), form.payrollSchedule))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div style={{display:'flex', gap:8, marginTop:16}}>
                      <button onClick={() => saveEdit(emp.id)} style={S.btnPrimary}>💾 Save</button>
                      <button onClick={() => setEditingId(null)} style={S.btnSecondary}>Cancel</button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

const S = {
  kpiRow:      { display:'flex', gap:12, flexWrap:'wrap', marginBottom:20 },
  kpiBox:      { background:'white', borderRadius:10, padding:'12px 20px', textAlign:'center', minWidth:120, border:'1px solid #e2e8f0', boxShadow:'0 1px 3px rgba(0,0,0,.06)' },
  kpiVal:      { fontSize:18, fontWeight:700, marginBottom:2 },
  kpiLabel:    { fontSize:11, color:'#64748b', fontWeight:500 },
  filterBar:   { background:'white', borderRadius:12, padding:'14px 20px', marginBottom:16, display:'flex', gap:16, flexWrap:'wrap', alignItems:'center', boxShadow:'0 1px 3px rgba(0,0,0,.06)' },
  filterGroup: { display:'flex', flexDirection:'column', gap:4 },
  label:       { fontSize:12, fontWeight:600, color:'#374151' },
  input:       { border:'1px solid #d1d5db', borderRadius:8, padding:'8px 10px', fontSize:14, outline:'none', background:'#f9fafb' },
  note:        { fontSize:12, color:'#64748b', margin:0, fontStyle:'italic' },
  note2:       { fontSize:12, color:'#64748b', marginTop:12, padding:'10px 14px', background:'#f8fafc', borderRadius:8, lineHeight:1.7 },
  card:        { background:'white', borderRadius:12, padding:20, marginBottom:12, boxShadow:'0 1px 3px rgba(0,0,0,.08)', border:'1px solid #e2e8f0' },
  cardHeader:  { display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 },
  empInfo:     { flex:1 },
  empName:     { fontSize:16, fontWeight:700, color:'#1e293b', marginBottom:4 },
  empMeta:     { fontSize:13, color:'#64748b', display:'flex', alignItems:'center', flexWrap:'wrap', gap:4 },
  headerRight: { display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' },
  summaryChips:{ display:'flex', gap:6 },
  chip:        { background:'#dbeafe', color:'#1d4ed8', borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:600 },
  badge:       { borderRadius:20, padding:'2px 8px', fontSize:11, fontWeight:600 },
  editBtn:     { background:'#4f46e5', color:'white', border:'none', borderRadius:8, padding:'6px 12px', cursor:'pointer', fontSize:13, fontWeight:600 },
  toggleBtn:   { background:'#f1f5f9', color:'#475569', border:'1px solid #e2e8f0', borderRadius:8, padding:'6px 12px', cursor:'pointer', fontSize:13, fontWeight:600 },
  detail:      { marginTop:16, paddingTop:16, borderTop:'1px solid #f1f5f9' },
  sectionTitle:{ fontSize:14, fontWeight:700, color:'#1e293b', marginBottom:12 },
  table:       { width:'100%', borderCollapse:'collapse', fontSize:13 },
  th:          { background:'#f8fafc', padding:'10px 12px', fontWeight:600, borderBottom:'2px solid #e2e8f0', color:'#374151', textAlign:'left' },
  td:          { padding:'10px 12px', borderBottom:'1px solid #f1f5f9', verticalAlign:'middle' },
  contribRow:  { background:'#f8fafc', borderRadius:10, padding:'14px 16px', marginBottom:12, border:'1px solid #e2e8f0' },
  contribLabel:{ fontSize:14, fontWeight:700, color:'#1e293b', marginBottom:10 },
  contribFields:{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:12 },
  formGroup:   { display:'flex', flexDirection:'column', gap:4 },
  autoField:   { border:'1px solid #e2e8f0', borderRadius:8, padding:'8px 10px', fontSize:14, background:'#f1f5f9', color:'#7c3aed', fontWeight:600 },
  btnPrimary:  { background:'#4f46e5', color:'white', border:'none', borderRadius:8, padding:'10px 20px', cursor:'pointer', fontWeight:600, fontSize:14 },
  btnSecondary:{ background:'#f3f4f6', color:'#374151', border:'1px solid #d1d5db', borderRadius:8, padding:'10px 20px', cursor:'pointer', fontWeight:600, fontSize:14 },
  empty:       { textAlign:'center', color:'#94a3b8', padding:'60px 0', fontSize:14 },
};
